//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { axiosGet } from '../../../axios/axios.js'

import DispatcherTasksTabSelectExecutor from '../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherTasksTabSelectExecutor.vue'
import TaskBackdateExecutorField from './TaskBackdateExecutorField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'

export default {
  components: {
    TaskBackdateExecutorField
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    timeChangeConfig: {
      type: Object,
      default: null
    }
  },
  data: function () {
    let requestCreateTime = null
    let reportCreateTime = null
    if (this.timeChangeConfig) {
      requestCreateTime = this.timeChangeConfig.requestTime || null

      const reportsTimes = this.timeChangeConfig.reportsTimes
      if (reportsTimes) {
        reportCreateTime = reportsTimes[0].time || null
      }
    }

    return {
      requestCreateTime,
      reportCreateTime,

      executionConfiguration: this.createExecutionConfiguration(requestCreateTime, reportCreateTime),

      brigadeSelection: null,
      appointmentConfig: null
    }
  },
  computed: {
    taskStatus: function () {
      return this.request.bpStateId
    },
    beforeAppointment: function () {
      return this.taskStatus === 'BS1' || this.taskStatus === 'BS2'
    },
    reportExecutorName: function () {
      return this.brigadeSelection ? this.brigadeSelection.name || 'Исполнитель без названия' : ''
    }
  },
  watch: {
  },
  created: function () {
  },
  methods: {
    createExecutionConfiguration: function (requestCreateTime, reportCreateTime) {
      const executionConfiguration = {
        appointmentDispatcher: {
          value: null,
          label: 'Диспетчер, назначивший исполнителя',
          fieldConfig: this.createExecutorFieldConfig('dispatcher', requestCreateTime)
        },
        reportChecker: {
          value: null,
          label: 'Аналитик, проверивший отчёт',
          fieldConfig: this.createExecutorFieldConfig('reportchecker', reportCreateTime)
        },
        closureDispatcher: {
          value: null,
          label: 'Диспетчер, закрывший заявку',
          fieldConfig: this.createExecutorFieldConfig('dispatcher', reportCreateTime)
        }
      }

      for (const key in executionConfiguration) {
        const conf = executionConfiguration[key]
        conf.key = key
      }

      return executionConfiguration
    },

    getResultConfig: function () {
      const executionConfiguration = this.executionConfiguration

      const config = {
        appointmentDispatcher: { id: executionConfiguration.appointmentDispatcher.value.id },
        reportChecker: { id: executionConfiguration.reportChecker.value.id },
        closureDispatcher: { id: executionConfiguration.closureDispatcher.value.id },
        appointmentConfig: this.appointmentConfig
      }
      return config
    },
    onApply: function () {
      const config = this.getResultConfig()
      this.$emit('confirm', config)
    },
    onCancel: function () {
      this.$emit('cancel')
    },

    // ---

    createExecutorFieldConfig: function (role, workTime) {
      const request = this.request
      return createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 0,
        cached: false,
        proxy: {
          urlBase: '/service/delta/requestBusinessProcess/special/searchAutoCompletionEmployees',
          searchParamKey: 'name',
          // filterType: 'stock',
          // formId: 'stockInventoryTask',
          get urlParams () {
            const params = {}
            params.request = request.requestId || null
            params.role = role
            if (workTime != null) {
              params.workTime = workTime
            }
            return params
          }
        }
      }))
    },

    // ---

    onSelectReportExecutor: async function () {
      if (this.beforeAppointment) {
        const brigadeSelection = await this.selectAutoCompleteBrigade(this.reportCreateTime)
        if (!brigadeSelection) {
          return
        }

        const appointmentConfig = {
          brigadeId: brigadeSelection.brigadeId,
          ignoreEndWorkTime: true,
          workDate: brigadeSelection.workDateMillis,
          workShift: brigadeSelection.workShift,
          // requests
          append: true
        }

        this.brigadeSelection = brigadeSelection
        this.appointmentConfig = appointmentConfig
      }
    },

    selectAutoCompleteBrigade: function (workTime) {
      return new Promise((resolve, reject) => {
        const dialog = this.$d.dialog(this).show({
          maximizedOnNarrow: true,
          persistent: true,
          noWrap: true,
          contentWidth: 560,
          contentComponent: DispatcherTasksTabSelectExecutor,
          contentProps: {
            opened: true,
            updateOnOpen: true,
            selectedRequestsIds: this.request.requestId ? [this.request.requestId] : [],
            singleRequest: this.request,
            selectMode: true,
            workTimeRequired: workTime
          },
          componentHandlers: {
            close: () => {
              dialog.hide()
              resolve(null)
            },
            select: (brigadeSelection) => {
              dialog.hide()
              resolve(brigadeSelection)
            }
          }
        })
      })
    }
  }
}
